import React = require('react');
import { IconCircle } from '../../../../../../components/Icons/IconCircle';
import { IPolicyApplication, IPremium } from '../../../../../../data/api/models';
import { capitalize, get, startCase, toLower } from 'lodash';
import { addYears, format, parse, subDays } from 'date-fns'

interface IApplicationOverview {
  premium: IPremium;
  quote: IPolicyApplication;
}

const DATE_FORMAT = 'dd/MM/yyyy';

export const ApplicationOverview = ({ premium, quote }: IApplicationOverview) => {

  if (!quote) {
    return null;
  }

  const renderStates = (): string => {
    if (quote.stateCities && quote.stateCities.length) {
      return quote.stateCities.join(', ');
    }
    return '';
  }

  const isAnnual = get(quote, 'tripType') === 'annual';
  const maxTripDuration = get(quote, 'maxTripDuration');
  const stateCities = renderStates();
  let endDate = quote.endDate ? format(parse(quote.endDate, DATE_FORMAT, new Date()), DATE_FORMAT) : '';

  if (quote.startDate !== '' && quote.endDate === '') {
    endDate = format(subDays(addYears(parse(quote.startDate, 'dd/MM/yyyy', new Date()), 1), 1), 'dd/MM/yyyy');
  }

  const renderDestinations = (): string => {
    if (quote.region) {
      const region = quote.region === 'uk' ? 'United Kingdom' : quote.region;
      return startCase(toLower(region));
    }

    if (quote.destinations) {
      return quote.destinations.join(', ');
    }

    return '';
  }

  return (
    <div className={'details-overview'}>
      <div className={'details-overview-header'}>
        <div className={'d-overview-icon'}>
          <img src={require('../../../MakeAChange/Images/clipboard.svg')} width={'50px'}/>
        </div>
        <div className={'d-overview-text'}>Quote Overview</div>
      </div>

      <div className={'details-overview-row'}>
        <div className={'d-o-attribute'}>
          <div>Trip Start Date</div>
          <div className={'d-o-attribute-value'}>{quote?.startDate}</div>
        </div>
      </div>
      <div className={'details-overview-row'}>
        <div className={'d-o-attribute'}>
          <div>Trip End Date</div>
          <div className={'d-o-attribute-value'}>{endDate}</div>
        </div>
      </div>
      <div className={'details-overview-row'}>
        <div className={'d-o-attribute'}>
          <div>Tier</div>
          <div className={'d-o-attribute-value'}>{capitalize(premium?.scheme?.coverLevel)}</div>
        </div>
      </div>
      <div className={'details-overview-row'}>
        <div className={'d-o-attribute'}>
          <div>Destination</div>
          <div className={'d-o-attribute-value'}>{renderDestinations()}</div>
        </div>
      </div>

      {!isAnnual && stateCities.length > 0 && (
        <div className={'details-overview-row'}>
          <div className={'d-o-attribute'}>
            <div>States and Cities</div>
            <div className={'d-o-attribute-value'}>{renderStates()}</div>
          </div>
        </div>
      )}

      {isAnnual && maxTripDuration && (
        <div className={'details-overview-row'}>
          <div className={'d-o-attribute'}>
            <div>Maximum individual trip length</div>
            <div className={'d-o-attribute-value'}>{maxTripDuration}</div>
          </div>
        </div>
      )}

    </div>
  )
}
